function loadPage(component, path = '') {
  // '@' is aliased to src/module
  let importPath = (path) ? path + '/' : '';
  return () => import(`@/components/page/` + importPath + `${component}.vue`)
}
const routes = {
  admin: [
    {path: 'germany/ship_agency/order_list_all', component: loadPage('OrderList', 'shipagency')},
    {path: 'germany/ship_agency/order_list_request', component: loadPage('OrderList', 'shipagency')},
    {path: 'germany/ship_agency/order_list_pay_req', component: loadPage('OrderList', 'shipagency')},
    {path: 'germany/ship_agency/order_list_pay_done', component: loadPage('OrderList', 'shipagency')},
    {path: 'germany/ship_agency/order_list_shipping', component: loadPage('OrderList', 'shipagency')},
    {path: 'germany/ship_agency/order_list_done', component: loadPage('OrderList', 'shipagency')},
    {path: 'germany/ship_agency/order_list_cancel', component: loadPage('OrderList', 'shipagency')},
    {path: 'germany/ship_agency/order_detail', component: loadPage('OrderDetail', 'shipagency')},
    {path: 'germany/ship_agency/receipts', component: loadPage('Receipts', 'shipagency')},

    {path: 'france/ship_agency/order_list_all', component: loadPage('OrderList', 'shipagency')},
    {path: 'france/ship_agency/order_list_request', component: loadPage('OrderList', 'shipagency')},
    {path: 'france/ship_agency/order_list_pay_req', component: loadPage('OrderList', 'shipagency')},
    {path: 'france/ship_agency/order_list_pay_done', component: loadPage('OrderList', 'shipagency')},
    {path: 'france/ship_agency/order_list_shipping', component: loadPage('OrderList', 'shipagency')},
    {path: 'france/ship_agency/order_list_done', component: loadPage('OrderList', 'shipagency')},
    {path: 'france/ship_agency/order_list_cancel', component: loadPage('OrderList', 'shipagency')},
    {path: 'france/ship_agency/order_detail', component: loadPage('OrderDetail', 'shipagency')},
    {path: 'france/ship_agency/receipts', component: loadPage('Receipts', 'shipagency')},

    {path: 'ship_agency/bank_account', component: loadPage('BankAccount', 'shipagency')},
    {path: 'ship_agency/exchange_rate', component: loadPage('ExchangeRateList', 'shipagency')},
  ]
}

export default routes;
